import { render } from "./BannerVideoSection.vue?vue&type=template&id=5d9516db"
import script from "./BannerVideoSection.vue?vue&type=script&lang=js"
export * from "./BannerVideoSection.vue?vue&type=script&lang=js"

import "./BannerVideoSection.vue?vue&type=style&index=0&id=5d9516db&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__